/**
 * TODO all need to
 */

// ============================================================
// TODO 基础协议命令
// ============================================================
import { VT_NRF54L_HID_REPORT } from '@rapoo/device-sdk'

export const CMD_LM20_RT = {
  // 鼠标
  switch_work_mode: [0xa0],
  firmware_version: [0xa3, 0xb0], // a3 指鼠標 b0是接收器的
  read_eeprom: [0xa4],
  write_eeprom: [0xa5],
  cfg_select: [0xa6],
  reset_device: [0xa7],
  firmware_update: [0xa8, 0xb1],
  get_dpi: [0xa9],
  read_battery: [0xaa],
  init_default_flash: [0xad],

  enter_rt_cal: [0xb0], //进入RT校准模式 cal = calibration
  exit_rt_cal: [0xb1], //退出RT校准模式不保存
  exit_and_save_rt_cal: [0xb2], //退出RT校准模式并保存
  restart_rt_cal: [0xb3], //重新开始校准
  get_rt_cal_status: [0xb4], //读取校准状态
  get_rt_cal_active_status: [0xb5], //读取当前触发状态

  code_match_mode: [0xa1, 0x8f],
  clear_code_status: [0xa1, 0x82],
  device_pairing_status: [0xa1, 0x01],
  read_work_mode: [0xa7],
} as const

// ============================================================
// 协议通用配置（Report ID / ACK 值等）
// ============================================================
export const PROTOCOL_CONFIG_LM20_RT = {
  report_id: VT_NRF54L_HID_REPORT.outputReportId,
  feature_report_id: VT_NRF54L_HID_REPORT.featureReportId,
  busy_ack_value: VT_NRF54L_HID_REPORT.busyAck, // 0x02 表示设备忙碌，需要重试
  read_ack_value: VT_NRF54L_HID_REPORT.okAck, // 0x01 表示读取成功
} as const

// TODO 升级的内容
